<template>
    <div class="memory-index-page">
        <full-loading ref="fullLoading"></full-loading>
        <!-- <asset-tabs :active="'memory'"></asset-tabs> -->
        <div class="page-tools-content" style="margin: 0; padding: 0;">
            <div class="left">
                <el-tabs class="filter-tabs memory-type-tabs" v-model="activeFilter" @tab-click="filterClickEvent">
                    <el-tab-pane :label="$t('asset.memory_index_page_tab_label_1')" name="ALL"></el-tab-pane>
                    <el-tab-pane :label="$t('asset.memory_index_page_tab_label_2')" name="CUSTOM_LIBRARY"></el-tab-pane>
                    <el-tab-pane :label="$t('asset.memory_index_page_tab_label_3')" name="DEFAULT_LIBRARY"></el-tab-pane>
                    <el-tab-pane :label="$t('asset.memory_index_page_tab_label_4')" name="MY"></el-tab-pane>
                </el-tabs>
            </div>
            <div class="right">
                <div style="width:120px;" @click="showSearchDialog">
                    <el-input class="cursor-pointer" :placeholder="$t('asset.memory_index_page_search_input_placeholder')" readonly
                        size="small" round suffix-icon="el-icon-search" maxlength="100" clearable 
                        v-model="searchForm.kw" @input="inputSearchEvent"></el-input>
                </div>
                <el-tooltip placement="top" :content="$t('asset.memory_index_page_button_text_1')">
                    <el-button class="margin-l-10" type="grey" size="small" round icon="el-icon-plus" v-permission="`memory:memoryStoreRouter:new`" @click="showCreateDialog" style="padding: 6.4px; font-size: 18px;"></el-button>
                </el-tooltip>
                <el-tooltip placement="top" :content="$t('asset.memory_index_page_button_text_2')">
                    <el-button class="margin-l-10" size="small" plain round icon="el-icon-connection" v-permission="`memory:memoryStoreRouter:merge`" @click="showMergeDialog" style="padding: 6.4px; font-size: 18px;"></el-button> <!-- :disabled="mergeBtnDisabled" -->
                </el-tooltip>
                <el-tooltip placement="top" :content="$t('asset.memory_index_page_button_text_3')">
                    <el-button size="small" plain round v-permission="``" @click="showDeleteDialog" style="padding: 6.4px; font-size: 18px;">
                        <svg-icon name="ib-trash-o-1"></svg-icon>
                    </el-button>
                </el-tooltip>
                <div class="margin-l-10">
                    <el-popover placement="bottom" trigger="click">
                        <div class="more-filter-content">
                            <el-form label-width="90px" style="width: 290px;">
                                <el-form-item :label="$t('asset.memory_index_page_search_select_placeholder_3')" class="margin-b-5" v-if="userInfo.organizationType === 'ENTERPRISE'">
                                    <el-select size="small" :placeholder="$t('asset.memory_index_page_search_select_placeholder_3')" clearable v-model="searchForm.teamId" @change="selectSearchEvent">
                                        <template v-for="item in teamOptions">
                                            <el-option :key="item.value" :value="item.value" :label="item.text"></el-option>
                                        </template>
                                    </el-select>
                                </el-form-item>
                                <!-- <el-form-item :label="$t('asset.memory_index_page_search_select_placeholder_4')" class="margin-b-5">
                                    <el-select size="small" :placeholder="$t('asset.memory_index_page_search_select_placeholder_4')" clearable v-model="searchForm.creator" @change="selectSearchEvent">
                                        <template v-for="item in creatorOptions">
                                            <el-option :key="item.value" :value="item.value" :label="item.text"></el-option>
                                        </template>
                                    </el-select>
                                </el-form-item> -->
                                <el-form-item :label="$t('asset.memory_index_page_search_select_placeholder_1')" class="margin-b-5">
                                    <el-select v-model="searchForm.source" size="small" filterable clearable :placeholder="$t('asset.memory_index_page_search_select_placeholder_1')" @change="selectSearchEvent">
                                        <template v-for="(item,key) in LANGUAGE_DICT">
                                            <el-option :key="key" :value="key" :label="item.name" :disabled="searchForm.target === item.key"></el-option>
                                        </template>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('asset.memory_index_page_search_select_placeholder_2')" class="margin-b-5">
                                    <el-select v-model="searchForm.target" size="small" filterable clearable :placeholder="$t('asset.memory_index_page_search_select_placeholder_2')" @change="selectSearchEvent">
                                        <template v-for="(item,key) in LANGUAGE_DICT">
                                            <el-option :key="key" :value="key" :label="item.name" :disabled="searchForm.source === item.key"></el-option>
                                        </template>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('asset.memory_index_page_search_select_placeholder_6')" class="margin-b-5">
                                    <el-select v-model="searchForm.merge" size="small" clearable :placeholder="$t('asset.memory_index_page_search_select_placeholder_6')" @change="selectSearchEvent">
                                        <template v-for="(item, index) in mergeOptions">
                                            <el-option :key="index" :value="item.value" :label="item.name"></el-option>
                                        </template>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('asset.memory_index_page_search_select_placeholder_5')" class="margin-b-5">
                                    <el-date-picker v-model="searchForm.createTime" @change="selectSearchEvent" range-separator="-" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" round size="small" :placeholder="$t('asset.memory_index_page_search_select_placeholder_5')" clearable style="width: 100%;"></el-date-picker>
                                </el-form-item>
                            </el-form>
                           
                        </div>
                        <el-badge slot="reference" :value="filterCount" class="more-filter-badge" :hidden="filterCount === 0">
                            <el-button plain round size="small" style="padding: 6.4px; font-size: 18px;">
                                <svg-icon name="ib-funnel"></svg-icon>
                            </el-button>
                        </el-badge>
                    </el-popover>
                </div>
                <div class="margin-l-10">
                    <el-tooltip :content="`${$t('asset.memory_index_page_tips_1')}${view === 'card' ? $t('asset.memory_index_page_tips_2') : $t('asset.memory_index_page_tips_3')}${$t('asset.memory_index_page_tips_4')}`" placement="top">
                        <el-button plain round size="small" @click="changeViewEvent" style="padding: 6.4px; font-size: 18px;">
                            <svg-icon name="ib-list" v-if="view === 'card'"></svg-icon>
                            <svg-icon name="ib-card" v-if="view === 'list'"></svg-icon>
                        </el-button>
                    </el-tooltip>
                </div>
            </div>
        </div>
        <template v-if="list.length > 0">
            <div class="card-list" style="margin-top: 30px;" v-if="view === 'card'">
                <template v-for="(item,index) in list">
                    <div class="item" :key="index" @click="gotoDetailPage(item)">
                        <div class="left">
                            <el-tooltip placement="top-start">
                                <div slot="content" class="fonts-12 line-height-2">
                                    {{$t('asset.memory_index_page_card_item_label_1')}}{{item.name||'—'}}<br>
                                    <template v-if="userInfo.organizationType === 'ENTERPRISE' && item.team">
                                        {{$t('asset.memory_index_page_card_item_label_2')}}{{item.team.teamName}}<br>
                                    </template>
                                    <template v-if="userInfo.organizationType === 'ENTERPRISE'">
                                        {{$t('asset.memory_index_page_card_item_label_3')}}{{item.createBy}}<br>
                                        {{$t('asset.memory_index_page_card_item_label_5')}}{{item.createTime}}<br>
                                        {{$t('asset.memory_index_page_card_item_label_6')}}{{item.updateBy}}<br>
                                        {{$t('asset.memory_index_page_card_item_label_7')}}{{item.updateTime}}
                                    </template>
                                </div>
                                <div class="title">
                                    <i class="el-icon-connection" style="margin-right: 2px;" v-if="item.mergeStatusTips?.merge"></i>{{item.name||'—'}}
                                </div>
                            </el-tooltip>
                            <div class="info">
                                <span class="language" v-if="LANGUAGE_DICT">
                                    {{LANGUAGE_DICT[item.sourceLang].shortName}}
                                    <svg-icon name="ib-arrow-right" style="font-size:12px;margin:0 4px;"></svg-icon>
                                    {{LANGUAGE_DICT[item.targetLang].shortName}} 
                                </span>
                                <span class="split-line"></span>
                                <span class="size">{{item.nums||'0'}} {{$t('asset.memory_index_page_card_item_label_4')}}</span>
                            </div>
                            <div class="time">{{item.createTime}}</div>
                        </div>
                        <div class="right">
                            <div class="check" @click.stop 
                                :style="selectedMemoryIds.indexOf(item.memId)>-1?{'display':'block'}:{}">
                                <el-checkbox :value="selectedMemoryIds.indexOf(item.memId)>-1" @change="value=>itemCheckChange(value,item.memId)"></el-checkbox>
                            </div>
                            <div style="flex:1;"></div>
                            <div class="type-icon">
                                <svg-icon name="ib-memory"></svg-icon>
                            </div>
                            <div class="more-btn" @click.stop>
                                <el-dropdown placement="bottom" @command="(command)=>handleMoreCommand(command,item)">
                                    <svg-icon name="ib-more"></svg-icon>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item command="view" v-permission="`memory:memoryStoreRouter:detail`">{{$t('asset.memory_index_page_card_item_dropdown_label_1')}}</el-dropdown-item>
                                            <el-dropdown-item divided command="downloadExcel" v-permission="`memory:memoryStoreRouter:downloadExcel`">{{$t('asset.memory_index_page_card_item_dropdown_label_2')}}</el-dropdown-item>
                                            <el-dropdown-item command="downloadTMX" v-permission="`memory:memoryStoreRouter:downloadTMX`">{{$t('asset.memory_index_page_card_item_dropdown_label_3')}}</el-dropdown-item>
                                            <el-dropdown-item command="rename" v-permission="`memory:memoryStoreRouter:rename`">{{$t('asset.memory_index_page_card_item_dropdown_label_4')}}</el-dropdown-item>
                                            <el-dropdown-item command="delete" divided v-permission="`memory:memoryStoreRouter:delete`" style="color:#F56C6C;">{{$t('asset.memory_index_page_card_item_dropdown_label_5')}}</el-dropdown-item>
                                        </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
            <template v-else-if="view === 'list'">
                <el-table :data="list" @selection-change="handleTableSelectionChange" style="width: 100%;">
                  <el-table-column type="selection" width="50"></el-table-column>
                  <el-table-column :label="$t('asset.memory_index_page_table_column_item_label_1')" min-width="180" >
                    <template slot-scope="scope">
                        <el-tooltip placement="top-start">
                            <div slot="content" class="fonts-12 line-height-2">
                                {{$t('asset.memory_index_page_card_item_label_1')}}{{scope.row.name || '—'}}<br>
                                <template v-if="userInfo.organizationType === 'ENTERPRISE' && scope.row.team">
                                    {{$t('asset.memory_index_page_card_item_label_2')}}{{scope.row.team.teamName}}<br>
                                </template>
                                <template v-if="userInfo.organizationType === 'ENTERPRISE'">
                                    {{$t('asset.memory_index_page_card_item_label_3')}}{{scope.row.createBy}}<br>
                                    {{$t('asset.memory_index_page_card_item_label_5')}}{{scope.row.createTime}}<br>
                                    {{$t('asset.memory_index_page_card_item_label_6')}}{{scope.row.updateBy}}<br>
                                    {{$t('asset.memory_index_page_card_item_label_7')}}{{scope.row.updateTime}}
                                </template>
                            </div>
                            <template v-if="$checkPermission('memory:memoryStoreRouter:detail')">
                                <router-link :to="{path: '/asset/memory/detail', query: {id: scope.row.memId}}" class="title">
                                    <i class="el-icon-connection" style="margin-right: 2px;" v-if="scope.row.mergeStatusTips?.merge"></i>{{scope.row.name || '—'}}
                                </router-link>
                            </template>
                            <template v-else>
                                <div class="title">
                                    <i class="el-icon-connection" style="margin-right: 2px;" v-if="scope.row.mergeStatusTips?.merge"></i>{{scope.row.name || '—'}}
                                </div>
                            </template>
                        </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('asset.memory_index_page_table_column_item_label_2')" min-width="100">
                    <template slot-scope="scope">
                        <language-direction :source="scope.row.sourceLang" :target="scope.row.targetLang" type="half"></language-direction>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('asset.memory_index_page_table_column_item_label_3')" min-width="100">
                    <template slot-scope="scope">
                        {{scope.row.nums||'0'}} {{$t('asset.memory_index_page_card_item_label_4')}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="createBy" :label="$t('asset.memory_index_page_table_column_item_label_4')" min-width="100"></el-table-column>
                  <el-table-column prop="createTime" :label="$t('asset.memory_index_page_table_column_item_label_5')" min-width="100"></el-table-column>
                  <el-table-column :label="$t('asset.memory_index_page_table_column_item_label_6')" width="70">
                    <template slot-scope="scope">
                         <el-dropdown placement="bottom" @command="(command)=>handleMoreCommand(command, scope.row)">
                            <svg-icon name="ib-more" className="fonts-16 cursor-pointer"></svg-icon>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="view" v-permission="`memory:memoryStoreRouter:detail`">{{$t('asset.memory_index_page_card_item_dropdown_label_1')}}</el-dropdown-item>
                                <el-dropdown-item divided command="downloadExcel" v-permission="`memory:memoryStoreRouter:downloadExcel`">{{$t('asset.memory_index_page_card_item_dropdown_label_2')}}</el-dropdown-item>
                                <el-dropdown-item command="downloadTMX" v-permission="`memory:memoryStoreRouter:downloadTMX`">{{$t('asset.memory_index_page_card_item_dropdown_label_3')}}</el-dropdown-item>
                                <el-dropdown-item command="rename" v-permission="`memory:memoryStoreRouter:rename`">{{$t('asset.memory_index_page_card_item_dropdown_label_4')}}</el-dropdown-item>
                                <el-dropdown-item command="delete" divided v-permission="`memory:memoryStoreRouter:delete`" style="color:#F56C6C;">{{$t('asset.memory_index_page_card_item_dropdown_label_5')}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                  </el-table-column>
                </el-table>
            </template>
        </template>
        <div class="none-list-block" v-else>
            <div class="none-files-content">
                <svg-icon name="ib-empty"></svg-icon>
                <div class="info" v-if="queryType === 'search'">{{$t('asset.memory_index_page_empty_label_1')}}</div>
                <div class="info" v-else>{{$t('asset.memory_index_page_empty_label_2')}}</div>
            </div>
        </div>
        <div class="pagination-content" v-if="list.length > 0 && total > pageSize">
            <el-pagination 
                background 
                @current-change="handleCurrentChange"
                layout="total, prev, pager, next"
                :page-size="pageSize"
                :current-page="pageNumber"
                :total="total">
            </el-pagination>
        </div>
        <create-memory ref="createMemoryDialog" @success="initPage"></create-memory>
        <fulltext-search ref="fulltextSearchDialog"></fulltext-search>
        <el-dialog :title="$t('asset.memory_index_page_dialog_1_title')" center :visible.sync="nameDialog.show" destroy-on-close width="480px" top="20px" @close="nameDialog.form.name = ''">
            <el-form label-width="80px" style="margin-right:40px;">
                <el-form-item :label="$t('asset.memory_index_page_dialog_1_form_item_label_1')" required>
                    <el-input :placeholder="$t('asset.memory_index_page_dialog_1_form_item_placeholder_1')" v-model="nameDialog.form.name"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button round plain size="small" @click="nameDialog.show = false">{{$t('asset.memory_index_page_dialog_1_btn_label_1')}}</el-button>
                <el-button round type="primary" size="small" style="margin-left:30px;" :loading="nameDialog.loading" @click="saveRenameBtnEvent">{{$t('asset.memory_index_page_dialog_1_btn_label_2')}}</el-button>
            </div>
        </el-dialog>
        <el-dialog :title="$t('asset.memory_index_page_dialog_2_title')" center :visible.sync="mergeDialog.show" destroy-on-close width="480px" top="20px" @close="closeMergeDialogEvent">
            <el-form label-width="100px" style="margin-right:40px;">
                <el-form-item :label="$t('asset.memory_index_page_dialog_2_form_item_label_1')" required>
                    <el-input :placeholder="$t('asset.memory_index_page_dialog_2_form_item_placeholder_1')" v-model="mergeDialog.form.name"></el-input>
                </el-form-item>
                <el-form-item :label="$t('asset.memory_index_page_dialog_2_form_item_label_2')" required>
                    <div class="fonts-12">{{$t('asset.memory_index_page_dialog_2_tips_1')}}</div>
                    <el-radio-group v-model="mergeDialog.form.settingValue">
                      <el-radio label="MERGE_WITH_CONTEXT">{{$t('asset.memory_index_page_dialog_2_form_item_radio_label_1')}}</el-radio>
                      <el-radio label="OVERWRITE_EXISTING" class="margin-t-10">{{$t('asset.memory_index_page_dialog_2_form_item_radio_label_2')}}</el-radio>
                      <el-radio label="RETAIN_BOTH" class="margin-t-10">{{$t('asset.memory_index_page_dialog_2_form_item_radio_label_3')}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="">
                    <el-checkbox v-model="mergeDialog.form.isDeleted">{{$t('asset.memory_index_page_dialog_2_form_item_checkbox_label_2')}}</el-checkbox>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button round plain size="small" @click="mergeDialog.show = false">{{$t('asset.memory_index_page_dialog_2_btn_label_1')}}</el-button>
                <el-button round type="primary" size="small" :loading="mergeDialog.loading" @click="saveMergeBtnEvent">{{$t('asset.memory_index_page_dialog_2_btn_label_2')}}</el-button>
            </div>
        </el-dialog>
        <alert-dialog ref="alertDialogDom" 
            :message="alertInfo.message" 
            :type="alertInfo.type" 
            :buttonName="alertInfo.buttonName"
            :buttonType="alertInfo.buttonType"
            @confirmEvent="deleteMemoryEvent"></alert-dialog>
    </div>
</template>
<script>
import FullLoading from '@/components/FullLoading';
import CreateMemory from '@/views/assets/components/CreateMemory';
import { mapState } from 'vuex';
import AssetTabs from '../components/Tabs';
import AlertDialog from '@/components/AlertDialog';
import { memoryApi, commonApi } from '@/utils/api';
import config from '@/utils/config';
import FulltextSearch from '../components/FulltextSearch.vue';
import Template from '../../project/Template.vue';
import LanguageDirection from '@/components/LanguageDirection.vue';
export default {
    components:{AssetTabs, AlertDialog, FullLoading, CreateMemory, FulltextSearch, Template, LanguageDirection, },
    data(){
        return {
            domainAndEngineList: config.DOMAIN_AND_ENGINE_LIST,
            alertInfo:{
                message: this.$t('asset.memory_index_page_alert_info_message_1'),//'确定要删除这个记忆库吗？',
                type:'confirm', //alert ,confirm
                buttonName: this.$t('asset.memory_index_page_alert_info_buttonName_1'), //'确认删除',
                buttonType:'danger',
            },
            queryType:'init',
            searchTimer:null,
            searchForm:{
                kw:'',
                source: '',
                target: '',
                teamId: '',
                creator: '',
                merge: '',
                createTime: [], //创建时间
                sort:'1'
            },
            list:[],
            selectedMemoryIds:[],
            total:0,
            pageSize:25,
            pageNumber:1,
            
            nameDialog:{
                show:false,
                loading:false,
                form:{
                    name:'',
                    memId:null
                }
            },
            mergeBtnDisabled:true,
            mergeDialog:{
                show:false,
                loading:false,
                form:{
                    name:'',
                    settingValue: 'MERGE_WITH_CONTEXT',
                    isDeleted: false,
                }
            },
            teamOptions: [],
            creatorOptions: [],
            mergeOptions: [],
            activeFilter: 'ALL',
            view: 'list', // card
            filterCount: 0,
        }
    },
    computed:{
        ...mapState({
            engineConfig:state => state.common.engineConfig,
            userInfo: state => state.user.userData,
            LANGUAGE_DICT: state => state.common.LANGUAGE_DICT,
        })
    },
    methods: {
        initPage(){
            let url = `${memoryApi.memoryDB}`+
                        `?pageSize=${this.pageSize}`+
                        `&pageNumber=${this.pageNumber}`;
            if(this.activeFilter !== 'ALL'){
                if(this.activeFilter === 'MY'){
                    url = url + `&creator=${this.userInfo.memberId}`;
                }else {
                    url = url + `&libraryType=${this.activeFilter}`;
                }
            }
            if(this.searchForm.kw){
                url = url + `&name=${encodeURI(this.searchForm.kw)}`;
            }
            if(this.searchForm.source){
                url = url + `&sourceLang=${this.searchForm.source}`;
            }
            if(this.searchForm.target){
                url = url + `&targetLang=${this.searchForm.target}`;
            }
            if(this.searchForm.teamId){
                url = url + `&teamId=${this.searchForm.teamId}`;
            }
            if(this.searchForm.creator){
                url = url + `&memberId=${this.searchForm.creator}`;
            }
            if(this.searchForm.merge){
                url = url + `&merge=${this.searchForm.merge}`;
            }
            if(this.searchForm.createTime && this.searchForm.createTime.length) {
                url = url + `&createTimeStart=${this.searchForm.createTime[0]}`;
                url = url + `&createTimeEnd=${this.searchForm.createTime[1]}`;
            }
            this.$refs.fullLoading.setShow();
            this.$ajax.get(url).then(res=>{
                if(res.status === 200){
                    this.list = res.data.records;
                    this.total = res.data.total;
                }
            }).finally(()=>{
                this.$refs.fullLoading.setHide();
            })
        },
        inputSearchEvent(value){
            let self = this;
            if(this.searchTimer){
                clearTimeout(this.searchTimer);
            }
            this.searchTimer = setTimeout(()=>{
                if (value) {
                    self.queryType = 'search';
                }else{
                   self.queryType = 'init'; 
                }
                this.pageNumber = 1;
                self.initPage();
            },500);
        },
        selectSearchEvent(){
            if (this.searchForm.source||this.searchForm.target||this.searchForm.teamId) {
                self.queryType = 'search';
            }else{
                self.queryType = 'init'; 
            }
            this.pageNumber = 1;
            this.initPage();
        },
        handleCurrentChange(num){
            this.pageNumber = num;
            this.initPage();
        },
        itemCheckChange(value,id){
            if (value) {
                this.selectedMemoryIds.push(id);
            }else{
                let idx = this.selectedMemoryIds.indexOf(id);
                this.selectedMemoryIds.splice(idx,1);
            }
            if(this.selectedMemoryIds.length > 1){
                this.mergeBtnDisabled = false;
            }else{
                this.mergeBtnDisabled = true;
            }
        },
        gotoDetailPage(item){
            if (!this.$checkPermission('memory:memoryStoreRouter:detail')){
                this.$message.error(this.$t('asset.memory_index_page_validation_message_1'));
                return;
            }
            // this.$ls.set('memoryDbInfo',item);
            this.$router.push({path:'/asset/memory/detail',query:{id:item.memId}});
        },
        handleMoreCommand(command,item){
            switch(command){
                case 'view':
                    this.gotoDetailPage(item);
                    break;
                case 'downloadExcel':
                    this.downloadFileEvent('excel',item)
                    break;
                case 'downloadTMX':
                    this.downloadFileEvent('tmx',item)
                    break;
                case 'rename':
                    this.nameDialog.show = true;
                    this.nameDialog.form.name = item.name;
                    this.nameDialog.form.memId = item.memId;
                    break;
                case 'delete':
                    this.$refs.alertDialogDom.setShow(true);
                    this.selectedMemoryIds = [item.memId];
                    break;
            }
        },
        
        saveRenameBtnEvent(){
            let url = memoryApi.memoryDB;
            let postData=this.nameDialog.form;
            if(!postData.name){
                this.$message.error(this.$t('asset.memory_index_page_validation_message_2'));
                return;
            }
            this.nameDialog.loading = true;
            this.$ajax.put(url,postData).then(res=>{
                if(res.status === 200){
                    this.$message.success(this.$t('asset.memory_index_page_validation_message_3'));
                    this.nameDialog.show = false;
                    this.initPage();
                }
            }).finally(()=>{
                this.nameDialog.loading = false;
            })
        },
        showMergeDialog(){
            if(this.selectedMemoryIds.length < 2){
                this.$message.error(this.$t('asset.memory_index_page_validation_message_4'));
                return;
            }
            let baseItem = this.list.filter(item=>item.memId === this.selectedMemoryIds[0])[0];
            let flag = true;
            for(let k = 0; k < this.selectedMemoryIds.length; k++){
                let id = this.selectedMemoryIds[k];
                for(let i = 0; i < this.list.length; i++){
                    let item = this.list[i];
                    if(id === item.memId){
                        if(baseItem.sourceLang !== item.sourceLang || baseItem.targetLang !== item.targetLang){
                            if(flag) flag = false;
                            break;
                        }
                    }
                }
                if(!flag){
                    break;
                }
            }
            if(!flag){
                this.$message.error(this.$t('asset.memory_index_page_validation_message_5'));
                return;
            }
            this.mergeDialog.show = true;
        },
        closeMergeDialogEvent(){
            this.mergeDialog.form = {
                name:'',
                settingValue: 'MERGE_WITH_CONTEXT',
                isDeleted: true,
            };
        },
        saveMergeBtnEvent(){
            if(!this.mergeDialog.form.name){
                this.$message.error(this.$t('asset.memory_index_page_validation_message_6'));
                return;
            }
            let url = memoryApi.mergeMemory;
            let postData={
                isDelete:this.mergeDialog.form.isDeleted,
                newMemName:this.mergeDialog.form.name,
                selectedMemIds:this.selectedMemoryIds,
                mergeResolution: this.mergeDialog.form.settingValue,
            };
            this.mergeDialog.loading = true;
            this.$ajax.post(url,postData).then(res=>{
                if(res.status === 200){
                    this.$message.success(this.$t('asset.memory_index_page_validation_message_7'));
                    this.mergeDialog.show = false;
                    this.selectedMemoryIds = [];
                    this.mergeBtnDisabled = true;
                    this.initPage();
                }
            }).finally(()=>{
                this.mergeDialog.loading = false;
            });
        },
        showDeleteDialog() {
            if(this.selectedMemoryIds.length === 0){
                this.$message.error(this.$t('asset.memory_index_page_validation_message_9'));
                return;
            }
            this.$refs.alertDialogDom.setShow(true);
        },
        deleteMemoryEvent(){
            let url = memoryApi.deleteMemoryBatch;
            console.log()
            this.$ajax.post(url,this.selectedMemoryIds).then(res=>{
                if(res.status === 200){
                    this.$message.success(this.$t('asset.memory_index_page_validation_message_8'));
                    this.selectedMemoryIds = [];
                    this.initPage();
                }
            })
        },
        
        downloadFileEvent(type,item){
            let url = commonApi.batchCreateDownloadTask;
            this.$ajax.post(url, {
                metadataIdList: [item.memId], 
                title: item.name,
                metadataType: 'ASSET_MEM',
                moreOptions: {
                    exportFileType: type,
                }
            }).then(res=>{
                if(res.status === 200){
                    this.$store.dispatch('download/createNotices', res.data.map(item => { return { ...item, show: true}}));
                }
            }).finally(()=>{
                
            })
        },
        showCreateDialog(){
            this.$refs.createMemoryDialog.setShow(true);
        },
        queryTeamOptions() {
            let url = commonApi.queryTeamFilterOptions;
            this.$ajax.get(url).then(res => {
                if(res.status === 200) {
                    this.teamOptions = res.data.teamFilters;
                }
            });
        },
        showSearchDialog() {
            this.$refs.fulltextSearchDialog.setShow(true, 'memory', this.searchForm.source || '', this.searchForm.target || '', this.searchForm.teamId);
        },
        changeViewEvent() {
            if(this.view === 'card') {
                this.view = 'list';
            }else if(this.view === 'list') {
                this.view = 'card';
            }
            this.selectedMemoryIds = [];
            this.$ls.set('memoryListView', this.view);
        },
        filterClickEvent() {
            this.pageNumber = 1;
            this.initPage();
        },
        handleTableSelectionChange(val) {
            this.selectedMemoryIds = val.map(item => item.memId);
        },
        setFilterCount() {
            let count = 0;
            if(this.searchForm.teamId) count ++;
            if(this.searchForm.creator) count ++;
            if(this.searchForm.source) count ++;
            if(this.searchForm.target) count ++;
            if(this.searchForm.merge) count ++;
            if(this.searchForm.createTime && this.searchForm.createTime.length) count ++;
            this.filterCount = count;
        }
    },
    created(){
        this.mergeOptions = [
            {name: this.$t('asset.memory_index_page_mergeOptions_name_1'), value: 'UNMERGED'},
            {name: this.$t('asset.memory_index_page_mergeOptions_name_2'), value: 'MERGED'}
        ];
        this.setFilterCount();
    },
    mounted(){
        this.view = this.$ls.get('memoryListView') || 'list';
        this.activeFilter = this.$ls.get('memoryActiveFilter') || 'ALL';
        let _from = this.$ls.get('memorySearchFilterParams');
        if(_from) {
            if(this.userInfo.organizationType !== 'ENTERPRISE') {
                _from.teamId = '';
            }
            this.searchForm = _from;
        }
        this.initPage();
        if(this.$route.query.view && this.$route.query.view === 'new'){
            this.dialog.show = true;
        }
        if(this.userInfo.organizationType === 'ENTERPRISE') {
            this.queryTeamOptions();
        }
    },
    watch:{
        'searchForm': {
            deep: true,
            handler(val){
                console.log(val);
                this.$ls.set('memorySearchFilterParams', val);
                this.setFilterCount();
            }
        },
        'activeFilter'(val) {
            this.$ls.set('memoryActiveFilter', val);
        }
    }
}
</script>
<style lang="scss" scoped>
.memory-index-page{
    // padding: 20px;
    .memory-type-tabs {
        ::v-deep .el-tabs__nav-wrap {
            &::after {
                display: none;
            }
        }
        ::v-deep .el-tabs__item {
            height: 57.1px;
            line-height: 57.1px;
        }
    }
    .card-list{
        margin: 0 90px;
        display: grid;
        grid-gap: 29px;
        grid-template-columns: repeat(auto-fill,minmax(290px,1fr));
        > .item{
            // width: 320px;
            background: #FFFFFF;
            box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.05);
            border-radius: 10px;
            padding: 15px 20px;
            display: flex;
            cursor: pointer;
            border: 1px solid #ffffff;
            box-sizing: border-box;
            transition: border .3s;
            &:hover,&:focus{
                border: 1px solid #DFDFDF;
                box-sizing: border-box;
                
                .right{
                    > .check{
                        display: block;
                    }
                    > .type-icon{
                        display: none;
                    }
                    > .more-btn{
                        display: block;
                    }
                    
                }
            }
            .left{
                flex: 1;
                min-width: 0;
                div{
                    font-size: 12px;
                    // line-height: 20px;
                    margin-top: 20px;
                    svg{
                        font-size: 14px;
                        margin-right: 10px;
                    }
                    &.title{
                        margin-top: 0;
                        margin-right: 20px;
                        font-weight: 600;
                        font-size: 15px;
                        // line-height: 22px;
                        overflow:hidden; text-overflow:ellipsis; white-space:nowrap;
                    }
                    .split-line{
                        height: 22px;
                        border-left:1px solid #0000001A; 
                        margin: 0 10px;
                    }
                    &.time{
                        color:#808080;
                    }
                }
            }
            > .right{
                width: 50px;
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                align-items: flex-end;
                > .check{
                    display: none;
                }
                .type-icon, .more-btn{
                    width:50px;
                    height:24px;
                    line-height:24px;
                    text-align:center;
                    background-color: #EEEEEE;
                    border-radius:50px;
                    svg {
                        font-size: 16px;
                    }
                }
                .more-btn{
                    display: none;
                }
            }
        }
    }
    .pagination-content{
        margin-top: 50px;
        margin-bottom: 60px;
        text-align: center;
    }
}
</style>
